var TrackSelectModal = (function (base) {
  __extends(TrackSelectModal, base);

  function TrackSelectModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  }

    TrackSelectModal.prototype.activate = function (roadId, roadName, startKm) {
    var self = this;

    this.loadContent('api/roads/track')
      .then($modal => {

        $modal

          //Кнопка 'Выбрать' в окне выбора трека ТС
          .on('click', '[js=ok]', function () {

            var isValid = true;
            const $vcvm = $('#VehicleChooseValidationMessage', $modal);
            const $ftvm = $('#FromToValidationMessage', $modal);
            $vcvm.empty();
            $ftvm.empty();

            const table = $('#VehicleListItemTable', $modal).DataTable();
            const selectedRows = table.rows('.selected').data();
            const from = $('#From', $modal).val();
            const to = $('#To', $modal).val();

            if (!from || !to) {
              $ftvm.html('Обязательные поля');
              isValid = false;
            }

            if (selectedRows.length === 0) {
              $vcvm.html('Выбор ТС обязателен');
              isValid = false;
            }

            if (isValid) {

              const id = selectedRows[0].Id;
              $modal.busy();
              self.apiClient.get('Vehicles/TrackCoordinates', { id: id, from: from, to: to })
                .then(function (coordinates) {

                  $modal.busy(false);

                    ModalConductor.activate(RoadMapModal, roadId, roadName, coordinates, startKm)
                    .closed(modalResult => {

                      if (modalResult.ok) {
                        self.close({
                          ok: true,
                            coordinatesCsv: modalResult.coordinatesCsv,
                            length: modalResult.length
                        });
                      }
                    });
                })
                .catch(function (xhr, status) {
                  $modal.busy(false);
                  console.log(status);
                  //TODO: нужно каким-то образом уведомить пользователя о возникшей проблеме
                });
            }
          });
      });
  };

  return TrackSelectModal;
}(BaseModal));
